<template>
  <div>
    <va-modal
      :value="show"
      id="confirmationModal"
      :size="size"
      :noOutsideDismiss="noOutsideDismiss"
      :okText="okText"
      :okClass="okClass"
      :cancelText="cancelText"
      :hideDefaultActions="hideDefaultActions"
      :showOkay="showOkay"
      @ok="onClickOK"
      @cancel="onClickCancel">

      <div slot="header" class="modal-title">
        {{title}}
      </div>

      <div><b>{{ body }}</b></div>
      <slot name="body"></slot>

    </va-modal>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('modals.defaults.title')
      }
    },
    body: {
      type: String,
      required: false,
      default: function () {
        return this.$t('modals.defaults.body')
      }
    },
    size: {
      type: String,
      required: false,
      default: 'small',
      validator: (size) => ['large', 'medium', 'small'].includes(size)
    },
    okClass: {
      type: String,
      required: false,
      default: function () {
        return 'btn-primary'
      }
    },
    okDisabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
    okText: {
      type: String,
      required: false,
      default: function () {
        return this.$t('modals.buttons.confirm')
      }
    },
    okToClose: {
      type: Boolean,
      required: false,
      default: true
    },
    cancelClass: {
      type: String,
      required: false,
      default: function () {
        return 'btn-primary btn-cancelar'
      }
    },
    cancelText: {
      type: String,
      required: false,
      default: function () {
        return this.$t('modals.buttons.cancel')
      }
    },
    showOkay: {
      type: Boolean,
      required: false,
      default: true
    },
    hideDefaultActions: {
      type: Boolean,
      required: false,
      default: false
    },
    transitionDuration: {
      type: Number,
      required: false,
      default: 250,
      validator: (value) => {
        return Number.isInteger(value) && value >= 0
      }
    },
    noOutsideDismiss: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.show = true
    }, this.transitionDuration)
  },
  methods: {
    onClickCancel: function () {
      this.$emit('modal-canceled')
    },
    onClickOK: function () {
      this.$emit('modal-confirmed')
    },
    close: function () {
      this.$refs.confirmationModal.cancel()
    }
  }
}
</script>
